module.exports = __webpack_public_path__ + "static/media/question.04e5c3fd.svg";